module.exports = __webpack_public_path__ + "static/img/banner.3167d0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner.jpg
// module id = 64
// module chunks = 2